import api from './api';

export const reportService = {
  getSlaCompliance: (params) => api.get('/reports/sla-compliance', { params }),
  getAgentPerformance: (params) => api.get('/reports/agent-performance', { params }),
  exportPdf: (params) => api.get('/tickets/export/pdf', { params, responseType: 'blob' }),
};
